import React, { Component } from "react";
import styles from "../PricingWrapper.module.scss";
import SubNav from "../../../../shared/subnav/SubNav";
import Grid from "@material-ui/core/Grid";
import VehicleInfo from "../../../../shared/vehicleInfo/VehicleInfo";
import { vehicleInfo } from "./VehicleInfoMockData";
import DealerVehicles from "../dealerVehicles/DealerVehicles";
import BackToButton from "../../../../shared/backToButton/BackToButton";
import DealerOptions from "../dealerOptions/DealerOptions";
import { logMsg } from "../../../../common/Logger";
import {
  CHARGE,
  DEFAULT_VEHICLE,
  DEFAULT_YEAR,
  DISCOUNT,
  FEES_MAP,
  NONE,
  PRICING,
} from "../../../../common/Constants";
import DealerFees from "../dealerFees/DealerFees";
import PendingActionPrompt from "../../../../shared/pendingActionPrompt/PendingActionPrompt";
import PricingClient from "../../../../shared/clients/PricingClient";
import PendingActionClient from "../../../../shared/clients/PendingActionClient";
import UpperCaseText from "../../../../utils/UpperCaseText";
import FormattedLang from "../../../../utils/FormattedLang";
import {
  displayError,
  isUnknownError,
  PAGE_ERROR,
} from "../../../../errors/ErrorConstants";
import VehicleCatalogClient from "../../../../shared/clients/VehicleCatalogClient";
import { withTranslation } from "react-i18next";
import PricingSubNav from "./PricingSubNav";
import { NULL_OR_UNDEFINED } from "../../../../utils/EmpUtil";
import ListOfItems from "./ListOfItems";

class DealerCurrentPricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
      renderApp: false,
      hasError: [],
      buttonEnabled: undefined,
      pendingActionPrompt: false,
      pendingActionExist: false,
      modelData: null,
      selectedModel:
        this.props.location &&
        this.props.location.query &&
        this.props.location.query.model
          ? this.props.location.query.model
          : null,
      selectedYear:
        this.props.location &&
        this.props.location.query &&
        this.props.location.query.modelYear
          ? this.props.location.query.modelYear
          : null,
      catalogIds: [],
      optionsData: [],
      pricingData: [],
      feesData: [],
      released: [],
      yearDropDownValues: [],
      priceUpdatesAvailable: [],
      editChecked: false,
      rowEditSaved: false,
      rowEditedCheckbox: [],
      rowOptionsEditedCheckbox: [],
      rowFeesEditedCheckbox: [],
      rowPricingEditedCheckbox: [],
      newVehiclesReleasedList: [],
      newOptionsReleasedList: [],
      newlyReleased: false,
      errorMessage: undefined,
    };
    this.currencySymbol =
      this.props.localizedInfo && this.props.localizedInfo.defaultCurrency
        ? this.props.localizedInfo.defaultCurrency.symbol
        : this.props.t("CurrentPricing.na");
    this.newVehiclesReleased = false;
    this.originalPricing = [];
    this.originalOptions = new Map();
    this.originalFees = new Map();
    this.pricingDataUpdated = false;
    this.isDealerChanged = false;
    this.hasFeesChanged = false;
    this.hasVehiclesChanged = false;
    this.hasOptionsChanged = false;
    this.onboardedDealerGroup = this.props.user.getOnboardedDealerGroup(true);
    this.fees = [
      "additionalFees",
      "deliveryFee",
      "numberPlates",
      "firstRegFee",
      "cityFee",
      "handlingFee",
      "malusFee",
    ];
  }

  componentDidMount() {
    this.determinePAStatus();
    this.fetchVehicleLines();
  }

  componentWillUnmount() {
    if (this.props.user.showPricingWarningMessage && !this.isDealerChanged) {
      this.updatePricingWarning(false);
    }
  }

  onDealerChanged = (dealer, showAll = false) => {
    this.updatePricingWarning(this.pricingDataUpdated);
    this.isDealerChanged = true;
    this.props.onDealerChanged(dealer, showAll);
  };

  onModelChange = (event) => {
    if (event) {
      event.preventDefault();
    }

    this.getYears(this.state.modelData, event.target.value);

    this.getCatalogId(event.target.value, this.getMaxYear(event.target.value));

    this.setState(
      {
        selectedModel: event.target.value,
        selectedYear: this.getMaxYear(event.target.value),
        renderApp: false,
        selectedTab: 0,
        rowEditedCheckbox: [],
        rowFeesEditedCheckbox: [],
        rowPricingEditedCheckbox: [],
      },
      () => {
        this.fetchDealerPricing(true);
      }
    );
  };

  onYearChange = (event) => {
    this.getCatalogId(this.state.selectedModel, event.target.value);
    this.setState(
      {
        selectedYear: event.target.value,
        renderApp: false,
        selectedTab: 0,
        rowEditedCheckbox: [],
        rowFeesEditedCheckbox: [],
        rowPricingEditedCheckbox: [],
      },
      () => {
        this.fetchDealerPricing();
      }
    );
  };

  handleTabChange = (event, selectedTab) => {
    this.setState({ selectedTab });
  };

  fromPendingAction = () => {
    if (this.props.location && this.props.location.actionName === PRICING) {
      this.setState({
        selectedModel:
          this.props.location.query && this.props.location.query.model,
        selectedYear:
          this.props.location.query && this.props.location.query.modelYear,
      });
      this.props.location.query &&
        this.props.location.query.model &&
        this.props.location.query.modelYear &&
        this.getCatalogId(
          this.props.location.query.model,
          this.props.location.query.modelYear
        );
    }
  };

  getCatalogId = (selectedModel, selectedYear) => {
    const catalogIds = [];
    if (selectedYear !== null && selectedModel !== null) {
      this.state.modelData &&
        this.state.modelData.forEach((vehicleLine) => {
          if (
            vehicleLine.model === selectedModel &&
            (selectedYear === "All" ||
              vehicleLine.year.toString() === selectedYear.toString())
          ) {
            catalogIds.push(vehicleLine.catalogId);
          }
        });
      this.setState({ catalogIds });
    }
  };

  determinePAStatus() {
    this.pendingActionStatusForDealers =
      this.props.user.getPendingActionStatusForDealers(
        this.props.user.pendingActions,
        PRICING
      );
    this.disablePendingActionPrompt =
      this.pendingActionStatusForDealers.length === 0;
  }

  fetchDealerPricing(maxYear) {
    this.props.hideOrShow(true);
    const pricingData = [];
    const optionsData = [];
    const feesData = [];
    let released;
    let priceUpdatesAvailable;
    PricingClient.getDealerPricing(
      this.props.user,
      FormattedLang(this.props.lang),
      this.state.catalogIds
    )
      .then((res) => {
        if (
          res &&
          res.pricingResponses &&
          res.pricingResponses.length > 0 &&
          res.pricingResponses[0].result
        ) {
          const pricingResponses = res.pricingResponses;
          pricingResponses.forEach((data) => {
            data.result.products.forEach((entity) => {
              entity.vehiclePricingDetails.forEach((item) => {
                item["catalogId"] = entity.catalogId;
                item["vehicleLine"] = entity.vehicleLine;
                item["marketedSeries"] = entity.marketedSeries;
                item["marketedSeriesId"] = entity.marketedSeriesId;
                item["year"] = entity.year;
                item["ptvl"] = entity.ptvl;
                item["adjType"] = this.getAdjType(item.adj);
                pricingData.push(item);
              });
            });

            data.result.options.forEach((option) => {
              option["optionsAdjType"] = this.detectOptionsAdjType(option.adj);
              optionsData.push(option);
            });

            feesData.push(...data.result.fees);
            released = data.result.released;
            priceUpdatesAvailable = data.result.priceUpdatesAvailable;
          });
        } else if (
          res &&
          res.pricingResponses &&
          res.pricingResponses.length > 0 &&
          res.pricingResponses[0].error &&
          res.pricingResponses[0].error.messages &&
          res.pricingResponses[0].error.messages.length > 0
        ) {
          this.setState({
            errorMessage: res.pricingResponses[0].error.messages[0],
          });
        }

        this.getYears(this.state.modelData, this.state.selectedModel);

        this.setState({
          pricingData,
          optionsData,
          feesData,
          released,
          priceUpdatesAvailable,
          buttonEnabled: !released,
          editChecked: !this.state.released,
        });
        maxYear &&
          this.setState({
            selectedYear: this.getMaxYear(this.state.selectedModel),
          });
      })
      .catch((error) => {
        logMsg("reason", error);
        if (isUnknownError(error)) {
          this.setState({ hasError: [PAGE_ERROR] });
        }
      })
      .finally(() => {
        this.makeCopyOfData();
        this.checkNewVehiclesReleased();

        this.setState({ renderApp: true });

        this.props.hideOrShow(false);
      });
  }

  getAdjType = (adj) => {
    let valueDropDown = NONE;
    if (Math.sign(adj) === 1) {
      valueDropDown = CHARGE;
    } else if (Math.sign(adj) === -1) {
      valueDropDown = DISCOUNT;
    }
    return valueDropDown;
  };

  getDefaultModel = (vehicleLines) => {
    const models = vehicleLines.map((vehicleLine) => vehicleLine.model);
    return models.includes(this.state.selectedModel)
      ? this.state.selectedModel
      : models[0];
  };

  getMaxYear = (model) => {
    const years =
      this.state.modelData &&
      this.state.modelData
        .filter((x) => x.model === model)
        .map((model) => model.year);

    return Math.max.apply(Math, years);
  };

  getYears = (data, selectedModel) => {
    const years =
      data &&
      data
        .filter((x) => x.model === selectedModel)
        .map((model) => model.year.toString());

    this.setState({
      yearDropDownValues: years,
    });
  };

  detectOptionsAdjType = (optionAdjAmount) => {
    if (NULL_OR_UNDEFINED(optionAdjAmount)) {
      return NONE;
    }

    if (optionAdjAmount < 0) {
      return DISCOUNT;
    } else if (optionAdjAmount > 0) {
      return CHARGE;
    }

    return NONE;
  };

  fetchVehicleLines() {
    this.props.hideOrShow(true);
    let maxYear = false;
    const market = this.props.user.market;
    VehicleCatalogClient.getDealerVehicleLines(
      this.props.user,
      false,
      true,
      market
    )
      .then((res) => {
        this.setState({ modelData: res });
        if (this.props.location && this.props.location.actionName === PRICING) {
          const selectedModel = DEFAULT_VEHICLE,
            selectedYear = DEFAULT_YEAR;
          this.setState({
            selectedYear,
            selectedModel,
          });
          this.fromPendingAction();
        } else {
          let selectedModel, selectedYear;
          if (this.state.selectedYear !== null) {
            selectedModel = this.state.selectedModel;
            selectedYear = this.state.selectedYear;
          } else if (this.state.selectedModel !== null) {
            selectedModel = this.state.selectedModel;
            selectedYear = this.getMaxYear(selectedModel);
          } else {
            selectedModel = this.getDefaultModel(res);
            selectedYear = this.getMaxYear(selectedModel);
            maxYear = true;
          }
          this.setState({
            selectedYear,
            selectedModel,
          });
          this.getCatalogId(selectedModel, selectedYear);
        }
      })
      .catch((error) => {
        logMsg("reason", error);
        if (isUnknownError(error)) {
          this.setState({ hasError: [PAGE_ERROR] });
        }
      })
      .finally(() => {
        this.fetchDealerPricing(maxYear);
        this.props.hideOrShow(false);
      });
  }

  checkPendingActionExists = () => {
    if (this.props.user && this.props.user.pendingActions) {
      this.props.user.pendingActions.forEach((pendingAction) => {
        if (
          pendingAction.actionName &&
          pendingAction.actionName === PRICING &&
          pendingAction.attributes &&
          pendingAction.attributes.vehicleLines
        ) {
          pendingAction.attributes.vehicleLines.forEach((vehicleLine) => {
            if (
              vehicleLine.catalogId &&
              this.state.catalogIds.includes(vehicleLine.catalogId)
            ) {
              this.setState({ pendingActionExist: true });
            }
          });
        }
      });
    }
  };
  checkNewVehiclesReleased = () => {
    let buttonEnabled = false;
    const listOfReleasedItems = [];
    const listOfReleasedOptionItems = [];
    if (!this.state.released) {
      buttonEnabled = true;
    } else {
      this.state.feesData &&
        this.state.feesData.forEach((fees) => {
          if (!fees.released) {
            buttonEnabled = true;
          }
        });
    }

    this.state.pricingData &&
      this.state.pricingData.forEach((pricingRow) => {
        if (!pricingRow.released) {
          listOfReleasedItems.push(pricingRow);
        }
      });

    this.state.optionsData &&
      this.state.optionsData.forEach((optionsData) => {
        if (!optionsData.released) {
          listOfReleasedOptionItems.push(optionsData);
        }
      });

    this.setState({
      buttonEnabled,
      newVehiclesReleasedList: listOfReleasedItems,
      newOptionsReleasedList: listOfReleasedOptionItems,
    });
    this.checkPendingActionExists();
    this.newVehiclesReleased = buttonEnabled;
  };

  makeCopyOfData() {
    this.originalPricing = JSON.parse(JSON.stringify(this.state.pricingData));

    const originalOptionsData = JSON.parse(
      JSON.stringify(this.state.optionsData)
    );
    const optionsMap = new Map();
    originalOptionsData.forEach(function (val) {
      optionsMap.set(
        val.feature.concat(val.featureCondition, val.featureDesc),
        val
      );
    });
    this.originalOptions = optionsMap;

    const originalFeesData = JSON.parse(JSON.stringify(this.state.feesData));
    const feesMap = new Map();
    originalFeesData.forEach(function (val) {
      feesMap.set(val.entity, val);
    });
    this.originalFees = feesMap;
  }

  constructTabs() {
    return [
      {
        menuName: this.props.t("CurrentPricing.dealerFees"),
        enabled: true,
        id: "dealerFees",
      },
      {
        menuName: this.props.t("CurrentPricing.vehicles"),
        enabled: true,
        id: "vehicles",
      },
      {
        menuName: this.props.t("CurrentPricing.options"),
        enabled: true,
        id: "options",
      },
    ];
  }

  getFloatValue(data) {
    if (data !== null) {
      return parseFloat(data);
    } else return 0;
  }

  getNegativeValue(data) {
    if (data !== null) {
      const floatValue = parseFloat(data);
      return -Math.abs(floatValue);
    } else return 0;
  }

  // If the user updated the pricing data and clicks the update button then it will call this function to save the updated pricing records
  updatePricingData = (data) => {
    const dataMap = new Map();
    data.forEach(function (val) {
      dataMap.set(val.entityId, val);
    });

    let btnEnb = false;
    const rowCheckboxNumber = [];
    const modifiedSpecificationData = this.state.pricingData;
    if (modifiedSpecificationData !== null) {
      modifiedSpecificationData.forEach((specification) => {
        const modifiedRecord = dataMap.get(specification.entityId);
        if (
          this.getFloatValue(specification.adj) !==
          this.getFloatValue(modifiedRecord.adj)
        ) {
          specification.adj =
            modifiedRecord.adjType === DISCOUNT
              ? this.getNegativeValue(modifiedRecord.adj)
              : modifiedRecord.adj;

          specification.adjType = modifiedRecord.adjType;
        }
      });
    }
    const newPricingMap = new Map();
    this.state.pricingData.forEach((pricingRow) => {
      newPricingMap.set(pricingRow.entityId, pricingRow);
    });

    this.originalPricing.forEach((pricingRow) => {
      const newPricingRecord = newPricingMap.get(pricingRow.entityId);
      if (
        this.getFloatValue(pricingRow.adj) !==
        this.getFloatValue(newPricingRecord.adj)
      ) {
        btnEnb = true;
        rowCheckboxNumber.push(pricingRow.specs);
      }
    });

    // combining edited specs from fees and pricing
    const finalRowEditedList = [...rowCheckboxNumber];
    this.state.rowFeesEditedCheckbox.forEach((item) => {
      if (!finalRowEditedList.includes(item)) {
        finalRowEditedList.push(item);
      }
    });

    this.setState({
      buttonEnabled:
        btnEnb ||
        this.hasOptionsChanged ||
        this.hasFeesChanged ||
        this.newVehiclesReleased,
      editChecked: finalRowEditedList.length > 0,
      rowEditedCheckbox: finalRowEditedList,
      rowPricingEditedCheckbox: rowCheckboxNumber,
    });
    this.pricingDataUpdated = btnEnb;
    this.hasVehiclesChanged = btnEnb;
  };

  // If the user updated the options data and clicks the update button  then it will call this function to save the updated options records
  updateOptionsData = (latestOptionsData) => {
    const latestDataMap = new Map();

    latestOptionsData.forEach(function (latestOption) {
      const key = latestOption.feature.concat(
        latestOption.featureCondition,
        latestOption.featureDesc
      );

      latestDataMap.set(key, latestOption);
    });

    let btnEnb = false;
    const rowCheckboxNumber = [];

    const existingOptionsDataInState = this.state.optionsData;
    if (existingOptionsDataInState !== null) {
      existingOptionsDataInState.forEach((optionInState) => {
        const key = optionInState.feature.concat(
          optionInState.featureCondition,
          optionInState.featureDesc
        );
        const latestOptionRecord = latestDataMap.get(key);

        if (
          optionInState.adj !== latestOptionRecord.adj ||
          optionInState.optionsAdjType !== latestOptionRecord.optionsAdjType
        ) {
          optionInState.adj = latestOptionRecord.adj;
          optionInState.optionsAdjType = latestOptionRecord.optionsAdjType;
        }
      });
    }

    const newOptionsMap = new Map();
    this.state.optionsData.forEach((option) => {
      const key = option.feature.concat(
        option.featureCondition,
        option.featureDesc
      );

      newOptionsMap.set(key, option);
    });

    this.originalOptions.forEach((originalOption) => {
      const key = originalOption.feature.concat(
        originalOption.featureCondition,
        originalOption.featureDesc
      );

      const newOptionsRecord = newOptionsMap.get(key);
      if (
        originalOption.adj !== newOptionsRecord.adj ||
        originalOption.optionsAdjType !== newOptionsRecord.optionsAdjType
      ) {
        btnEnb = true;
        rowCheckboxNumber.push(originalOption.featureDesc);
      }
    });

    this.setState({
      buttonEnabled:
        btnEnb ||
        this.hasFeesChanged ||
        this.hasVehiclesChanged ||
        this.newVehiclesReleased,
      editChecked: rowCheckboxNumber.length > 0,
      rowOptionsEditedCheckbox: rowCheckboxNumber,
    });
    this.pricingDataUpdated = btnEnb;
    this.hasOptionsChanged = btnEnb;
  };

  // If the user updated the fees data and clicks the update button  then it will call this function to save the updated fees records
  updateFeesData = (data) => {
    const dataMap = new Map();
    data.forEach(function (val) {
      dataMap.set(val.entity, val);
    });
    let btnEnb = false;
    let feeChange = false;
    const rowCheckboxNumber = [];

    this.state.feesData.forEach((feesRow) => {
      const modifiedFees = dataMap.get(feesRow.entity);
      const originalData = this.originalFees.get(feesRow.entity);

      this.fees.forEach((fee) => {
        feesRow[fee] = this.getFloatValue(modifiedFees[fee]);
        if (
          this.getFloatValue(modifiedFees[fee]) !==
          this.getFloatValue(originalData[fee])
        ) {
          feeChange = true;
          rowCheckboxNumber.push(feesRow.specs);
        }
      });

      if (feeChange) {
        btnEnb = true;
      }
    });
    // combining edited specs from fees and pricing
    const finalRowEditedList = [...rowCheckboxNumber];
    this.state.rowPricingEditedCheckbox.forEach((item) => {
      if (!finalRowEditedList.includes(item)) {
        finalRowEditedList.push(item);
      }
    });

    this.setState({
      buttonEnabled:
        btnEnb ||
        this.hasOptionsChanged ||
        this.hasVehiclesChanged ||
        this.newVehiclesReleased,
      editChecked: finalRowEditedList.length > 0,
      rowFeesEditedCheckbox: rowCheckboxNumber,
      rowEditedCheckbox: finalRowEditedList,
    });
    this.pricingDataUpdated = btnEnb;
    this.hasFeesChanged = btnEnb;
  };

  //Format the save resposne which has both the pricing and the options data
  postResponse = () => {
    const pricingResponse = { pricing: [], options: [], fees: [] };
    const newPricingData = [];

    this.state.pricingData.forEach((pricingRow) => {
      pricingRow.adj =
        pricingRow.adjType === DISCOUNT
          ? this.getNegativeValue(pricingRow.adj)
          : pricingRow.adj;
      newPricingData.push(pricingRow);
    });

    pricingResponse.pricing = newPricingData;
    pricingResponse.options = this.state.optionsData;
    pricingResponse.fees = this.state.feesData;

    return pricingResponse;
  };

  saveDealerPricing = () => {
    const pendingActions =
      this.props.user.getPendingActionStatusForDealersByCatalogIdAndModelYear(
        this.props.user.pendingActions,
        PRICING,
        this.state.catalogIds,
        this.state.selectedModel,
        this.state.selectedYear
      );
    if (
      this.props.user.showAll &&
      this.onboardedDealerGroup.length > 1 &&
      !this.disablePendingActionPrompt &&
      pendingActions.length !== 0
    ) {
      this.setState({ pendingActionPrompt: true });
    } else {
      this.applyPricing(this.props.user.getDealerIdsWithoutSDLR());
    }
  };

  applyPricing(dealerIds) {
    const requestData = this.postResponse();
    if (
      (requestData.pricing && requestData.pricing.length > 0) ||
      (requestData.fees && requestData.fees.length > 0) ||
      (requestData.options && requestData.options.length > 0) ||
      this.state.priceUpdatesAvailable
    ) {
      this.props.hideOrShow(true);
      this.setState({ renderApp: false });
      PricingClient.saveDealerPricingCall(
        this.props.user,
        requestData,
        dealerIds,
        this.state.catalogIds
      )
        .then(() => {
          this.removePricingPendingAction(dealerIds);
        })
        .catch((err) => {
          logMsg("error", err);
        })
        .finally(() => {
          this.setState({
            buttonEnabled: false,
            pendingActionPrompt: false,
            rowEditSaved: true,
          });
          if (
            this.state.newVehiclesReleasedList.length !== 0 &&
            this.state.newOptionsReleasedList.length !== 0
          ) {
            this.setState({ newlyReleased: true });
          }
          if (this.props.user.showPricingWarningMessage) {
            this.updatePricingWarning(false);
          }
          this.pricingDataUpdated = false;
          this.fetchDealerPricing();
          this.props.hideOrShow(false);
        });
    }
  }

  removePricingPendingAction(dealerIds) {
    const vehicleLines =
      this.state.modelData &&
      this.state.modelData
        .filter(
          (vehicleInfo) =>
            this.state.catalogIds &&
            this.state.catalogIds.includes(vehicleInfo.catalogId)
        )
        .map((vehicleInfo) => vehicleInfo.vehicleLine);
    PendingActionClient.removeDealerPendingAction(
      this.props.user,
      dealerIds,
      PRICING,
      vehicleLines
    ).then(() => {
      this.props.getPendingActions().then(() => {
        this.setState({ pendingActionExist: false });
        this.determinePAStatus();
      });
    });
  }

  pendingActionPromptClose = () => {
    this.setState({ pendingActionPrompt: false });
  };

  pendingActionPromptApplyAll = () => {
    const dealerIds = this.pendingActionStatusForDealers[0].map((dealer) => {
      return dealer.dealerId;
    });
    this.applyPricing(dealerIds);
  };

  pendingActionPromptApplySelective = () => {
    //only apply values to dealers who have NOT completed pendingAction
    const dealerIds = this.pendingActionStatusForDealers[0]
      .filter((dealer) => !dealer.pendingActionStatus)
      .map((dealer) => {
        return dealer.dealerId;
      });
    this.applyPricing(dealerIds);
  };

  getSubHeader = () => {
    return (
      <PricingSubNav
        {...this.props}
        selectedTab={this.state.selectedTab}
        user={this.props.user}
        modelData={this.state.modelData}
        selectedModel={this.state.selectedModel}
        modelDropDownValues={this.state.modelDropDownValues}
        updateModel={this.onModelChange}
        yearValues={this.state.yearDropDownValues}
        updateYear={this.onYearChange}
        selectedYear={this.state.selectedYear}
        feesData={this.state.feesData}
        pricingData={this.state.pricingData}
        optionsData={this.state.optionsData}
        showAll={false}
      />
    );
  };

  vehicleTitle = () => {
    return (
      <Grid className={styles.infoBar} container>
        <Grid item xs={6}>
          <VehicleInfo
            vehicleTitle={vehicleInfo.vehicleTitle}
            year={vehicleInfo.year}
          />
        </Grid>
      </Grid>
    );
  };

  updatePricingWarning = (status) => {
    this.props.user.showPricingWarning(status);
  };

  getSubNav = () => {
    return (
      <div className={styles.left}>
        <SubNav
          {...this.props}
          title={this.props.t("DealerVehicles.currentPricing")}
          subTitle={this.vehicleTitle}
          renderSubHeader={true}
          subHeader={this.getSubHeader}
          selectedTab={this.state.selectedTab}
          action={this.handleTabChange}
          tabs={this.constructTabs()}
          onDealerChanged={this.onDealerChanged}
        />
      </div>
    );
  };

  getListOfItems = () => {
    return (
      <ListOfItems
        selectedTab={this.state.selectedTab}
        rowEditedCheckbox={this.state.rowEditedCheckbox}
        newVehiclesReleasedList={this.state.newVehiclesReleasedList}
        feesData={this.state.feesData}
        rowOptionsEditedCheckbox={this.state.rowOptionsEditedCheckbox}
        newOptionsReleasedList={this.state.newOptionsReleasedList}
        optionsData={this.state.optionsData}
        rowEditSaved={this.state.rowEditSaved}
      />
    );
  };

  render() {
    if (displayError(this.state.hasError))
      throw new Error(this.state.hasError[0]);

    return (
      this.state.renderApp && (
        <div className="pageWrapper">
          <BackToButton
            backToUrl="/pricing"
            display={this.props.t("PricingWrapper.backToPricing")}
          />
          {this.getSubNav()}
          {this.getListOfItems()}
          {this.state.selectedTab === 0 ? (
            <DealerFees
              {...this.props}
              errorMessage={this.state.errorMessage}
              selectedMarket={this.props.user.market}
              viewOnlyPricing={false}
              handleTabChange={this.handleTabChange}
              updateFeesData={this.updateFeesData}
              released={this.state.released}
              priceUpdatesAvailable={this.state.priceUpdatesAvailable}
              buttonEnabled={this.state.buttonEnabled}
              currencySymbol={this.currencySymbol}
              feesData={this.state.feesData}
              catalogIds={this.state.catalogIds}
              editChecked={this.state.editChecked}
              rowEditSaved={this.state.rowEditSaved}
              rowEditedCheckbox={this.state.rowEditedCheckbox}
              newlyReleased={this.state.newlyReleased}
              pendingActionExist={this.state.pendingActionExist}
            />
          ) : this.state.selectedTab === 1 ? (
            <DealerVehicles
              {...this.props}
              errorMessage={this.state.errorMessage}
              viewOnlyPricing={false}
              handleTabChange={this.handleTabChange}
              pricingData={this.state.pricingData}
              feesData={this.state.feesData}
              currencySymbol={this.currencySymbol}
              navigateToOptions={this.navigateToOptions}
              released={this.state.released}
              priceUpdatesAvailable={this.state.priceUpdatesAvailable}
              buttonEnabled={this.state.buttonEnabled}
              updatePricingData={this.updatePricingData}
              fees={FEES_MAP[UpperCaseText(this.props.user.market)]}
              catalogIds={this.state.catalogIds}
              editChecked={this.state.editChecked}
              rowEditSaved={this.state.rowEditSaved}
              rowEditedCheckbox={this.state.rowEditedCheckbox}
              newlyReleased={this.state.newlyReleased}
              pendingActionExist={this.state.pendingActionExist}
            />
          ) : (
            <DealerOptions
              {...this.props}
              errorMessage={this.state.errorMessage}
              viewOnlyPricing={false}
              released={this.state.released}
              priceUpdatesAvailable={this.state.priceUpdatesAvailable}
              optionsData={this.state.optionsData}
              buttonEnabled={this.state.buttonEnabled}
              savePricing={this.saveDealerPricing}
              updateOptionsData={this.updateOptionsData}
              currencySymbol={this.currencySymbol}
              isDisabled={true}
              catalogIds={this.state.catalogIds}
              editChecked={this.state.editChecked}
              rowEditSaved={this.state.rowEditSaved}
              rowOptionsEditedCheckbox={this.state.rowOptionsEditedCheckbox}
              newlyReleased={this.state.newlyReleased}
              pendingActionExist={this.state.pendingActionExist}
            />
          )}
          <PendingActionPrompt
            {...this.props}
            disabled={this.disablePendingActionPrompt}
            dealersActioned={
              this.disablePendingActionPrompt
                ? []
                : this.pendingActionStatusForDealers[0].filter(
                    (dealer) => dealer.pendingActionStatus
                  )
            }
            dealersNotActioned={
              this.disablePendingActionPrompt
                ? []
                : this.pendingActionStatusForDealers[0].filter(
                    (dealer) => !dealer.pendingActionStatus
                  )
            }
            title={this.props.t("PendingActionPrompt.pricing")}
            buttonTitle={this.props.t("PendingActionPrompt.pricingButton")}
            onClose={this.pendingActionPromptClose}
            open={this.state.pendingActionPrompt}
            applyAll={this.pendingActionPromptApplyAll}
            applySome={this.pendingActionPromptApplySelective}
          />
        </div>
      )
    );
  }
}

export default withTranslation("emp")(DealerCurrentPricing);
